import { CSSObject } from '@chakra-ui/react';
import errorBg from '@/assets/pyramidbet/images/background/bgError.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: 'center',
  alignItems: 'center',
  minH: '100dvh',
  fontFamily: 'accent',
  textAlign: 'center',
  bg: `url(${errorBg}) center/cover no-repeat`,
};

export const CenterWrapper: CSSObject = {
  alignItems: 'center',
  color: 'white',
  gap: '0',
  h: undefined,
  justifyContent: 'center',
  maxW: '500px',
  mb: [null, null, '12'],
  minH: [null, null, '480px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  pos: 'relative',
  px: ['4', null, '0'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
  zIndex: '1',

  _before: {
    content: '""',
    h: '275px',
    left: '0',
    pos: 'absolute',
    top: '0',
    w: 'full',
    zIndex: '-1',
  },
};

export const FlexHeaderContainer: CSSObject = {
  display: 'flex',
  justifyContent: 'center',
};

export const ContentHeadingText: CSSObject = {
  color: 'alpha.300',
  fontSize: ['xl', null, '26px'],
  fontWeight: 'extrabold',
  lineHeight: 'none',
  mb: '2.5',
  mt: '4',
  w: '100%',
  textTransform: 'uppercase',
};

export const ContentBodyText: CSSObject = {
  fontSize: ['xs', null, 'sm'],
  mb: '4',
  textAlign: 'center',
  color: 'white',
  fontWeight: 'semibold',
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  mt: '4',
  fontWeight: 'normal',
  fontSize: ['2xs', null, 'xs'],
  '.chakra-link': {
    color: 'alpha.300',
    fontWeight: 'bold',
    fontSize: ['2xs', null, 'xs'],
    textDecoration: 'none',
  },
};

export const RegistrationContent: CSSObject = {
  fontWeight: 'normal',
  fontSize: ['2xs', null, 'xs'],
  '.chakra-link': {
    textDecoration: 'none',
  },
};

export const TextLink: CSSObject = {
  textDecoration: 'none',
};
